import { Accordion } from '@base-ui/react/accordion';
import styled from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
export const Container = styled(Accordion.Item) `
  &:not(:last-child) {
    border-bottom: ${pxToRem(1)} solid ${theme.semantic.border.default};
  }

  padding: ${theme.spacing.xl};
`;
